import { createAction } from 'redux-actions';

export const startSignInSubmit = createAction('START_SIGN_IN_SUBMIT');

export const resolveSignInSubmit = createAction('RESOLVE_SIGN_IN_SUBMIT');
